import * as THREE from 'three';

/**
 * No audio content ships this milestone — this exists so the asset
 * pipeline has a real fourth pillar (Model/Texture/Material/Audio) instead
 * of a shape we hope holds up later. The one integration point worth
 * flagging: the AudioListener must be re-parented whenever the active
 * camera changes (see attachListenerTo), which isn't wired to
 * CameraManager yet — do that when camera switching is actually built.
 */
export class AudioManager {
  private readonly listener = new THREE.AudioListener();
  private readonly loader = new THREE.AudioLoader();
  private readonly bufferCache = new Map<string, Promise<AudioBuffer>>();

  attachListenerTo(camera: THREE.Camera): void {
    camera.add(this.listener);
  }

  private loadBuffer(url: string): Promise<AudioBuffer> {
    const cached = this.bufferCache.get(url);
    if (cached) return cached;

    const promise = this.loader.loadAsync(url);
    this.bufferCache.set(url, promise);
    return promise;
  }

  async createSound(
    url: string,
    options: { loop?: boolean; volume?: number } = {},
  ): Promise<THREE.Audio> {
    const buffer = await this.loadBuffer(url);
    const sound = new THREE.Audio(this.listener);
    sound.setBuffer(buffer);
    sound.setLoop(options.loop ?? false);
    sound.setVolume(options.volume ?? 1);
    return sound;
  }
}
